export default {
  namespaced: true,

  state: () => ({
    collections: {
      data: [],
      links: {},
      meta: {},
    },
    collection: {},
    isLoading: false,
    listType: ['homepage', 'registry', 'promotion'],
  }),

  getters: {},

  mutations: {
    SET_COLLECTION_LIST(state, payload) {
      state.collections = payload
    },
    SET_COLLECTION(state, payload) {
      state.collection = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getCollections({ commit }, { page = null } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/collections'

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_COLLECTION_LIST', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getCollection({ commit }, idCollection) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/collections/${idCollection}`

        const response = await this._vm.$http.get(url)

        commit('SET_COLLECTION', response.data.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        commit('SET_LOADING', false)
        return error
      }
    },
    async createCollectionInfo({ commit }, data) {
      try {
        commit('SET_LOADING', true)
        const url = 'v1/admin/collections'

        const formData = new FormData()
        if (data.imageFile) formData.append('image', data.imageFile)
        if (data.title) formData.append('title', data.title)
        if (data.slug) formData.append('slug', data.slug)
        if (data.type) formData.append('type', data.type)
        if (data.description) formData.append('description', data.description)
        if (data.is_active) formData.append('is_active', data.is_active)
        if (data.position) formData.append('position', data.position)
        if (data.category_id) formData.append('category_id', data.category_id)

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('SET_LOADING', false)
        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Koleksi!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Koleksi!',
        }, { root: true })
        commit('SET_LOADING', false)
        return error
      }
    },
    async updateCollectionInfo({ commit }, { data, collectionId }) {
      try {
        const url = `/v1/admin/collections/${collectionId}`

        const formData = new FormData()
        if (data.imageFile) formData.append('image', data.imageFile)
        if (data.title) formData.append('title', data.title)
        if (data.slug) formData.append('slug', data.slug)
        if (data.type) formData.append('type', data.type)
        if (data.description) formData.append('description', data.description)
        if (data.is_active) formData.append('is_active', data.is_active)
        if (data.position) formData.append('position', data.position)
        if (data.category_id) formData.append('category_id', data.category_id)
        formData.append('_method', 'PUT')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('SET_COLLECTION', response.data.data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Koleksi!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Koleksi!',
        }, { root: true })

        throw new Error(error.message)
      }
    },
    async onAttachProduct({ commit }, { collectionId, productId }) {
      try {
        const url = `v1/admin/collections/${collectionId}/attach-products`

        const response = await this._vm.$http.post(url, {
          product_id: productId,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Produk!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Produk!',
        }, { root: true })

        throw new Error(error.message)
      }
    },
    async onDetachProduct({ commit }, { collectionId, productId }) {
      try {
        const url = `v1/admin/collections/${collectionId}/detach-products`

        const response = await this._vm.$http.post(url, {
          product_id: productId,
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Produk dari Koleksi!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Produk dari Koleksi!',
        }, { root: true })

        throw new Error(error.message)
      }
    },
    async deleteCollection({ commit }, { collectionId }) {
      try {
        const url = `v1/admin/collections/${collectionId}`
        const response = await this._vm.$http.delete(url)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Koleksi!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Koleksi!',
        }, { root: true })
        return error
      }
    },
  },
}
